import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import { columnListApi } from "../apis/column";
import { ColumnDetail, ListResponse } from "../types";

const useGetColumnList = (pageNum: number, searchKnd: string, searchKeyword: string) => {
    return useQuery<AxiosResponse<ListResponse<ColumnDetail>>, Error>(['columnList', pageNum, searchKeyword], () => columnListApi(pageNum, searchKnd, searchKeyword),
        {
            retryDelay: 600000
            , refetchOnWindowFocus: false
        });
}

export default useGetColumnList;